var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          items: _vm.candledRackEggIndexList,
          headers: _vm.headers,
          page: _vm.page,
          "items-per-page": _vm.itemsPerPage,
          "server-items-length": _vm.candledRackEggIndexGetCount,
          loading: _vm.candledRackEggIndexGetting
        },
        on: {
          "update:page": function($event) {
            _vm.page = $event
          },
          "update:itemsPerPage": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:items-per-page": function($event) {
            _vm.itemsPerPage = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", lg: "6", md: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "search",
                            "append-icon": "mdi-magnify"
                          },
                          model: {
                            value: _vm.search,
                            callback: function($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", lg: "6", md: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: "date", type: "date" },
                          model: {
                            value: _vm.date,
                            callback: function($$v) {
                              _vm.date = $$v
                            },
                            expression: "date"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item.date",
            fn: function({ value }) {
              return [_c("span", [_vm._v(_vm._s(value.dateFormat()))])]
            }
          },
          {
            key: "item.rack_egg_id",
            fn: function({ item }) {
              return [
                _c("span", [_vm._v(_vm._s(item.rack_code.code))]),
                _vm.accessLevel > 5
                  ? _c(
                      "v-icon",
                      {
                        attrs: { color: "yellow darken-3" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("edit", item)
                          }
                        }
                      },
                      [_vm._v("mdi-pencil")]
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }